import React, { useState } from "react";
import { Controller } from "react-hook-form";
import { Button } from "reactstrap";

const FileUploadLegalDocument = ({ 
  control, 
  name, 
  label, 
  allowedFileTypes, 
  onFileChange, 
  onDelete, 
  uploadedFile, 
  setIsoFile, 
  setUplaodedFile, 
  uploadClass, 
  deleteClass, 
  uploaMainWrap 
}) => {
  const [inputKey, setInputKey] = useState(Date.now());
  const [fileName, setFileName] = useState("");

  const handleDelete = () => {
    if (onDelete) {
      onDelete();
    }
    setFileName("");
  };

  const isAcceptedFormat = (file) => {
    return file && allowedFileTypes?.includes(file?.type);
  };

  const handleFileChange = (file, field) => {
    if (file) {
      onFileChange(file).then(isValid => {
        if (!isValid) {
          // If validation fails, reset the input
          setFileName("");
          field.onChange(null);
          if (field.ref) {
            field.ref.value = "";
          }
        } else {
          setFileName(file.name);
        }
      });
    }
    setInputKey(Date.now());

    if (uploadedFile) {
      handleDelete();
    }
  };

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={null}
      render={({ field }) => (
        <div className={`hl-upload-delete-wrap ${uploaMainWrap || ''}`}>
          <input
            key={inputKey}
            type="file"
            onChange={(e) => {
              const file = e.target.files[0];
              field.onChange(file);
              handleFileChange(file, field);
            }}
            style={{ display: "none" }}
            ref={(inputRef) => (field.ref = inputRef)}
          />
          <div className="hl-upload-btn-small">
            <Button
              className={`hl-upload-btn right ${uploadClass || ''}`}
              variant="upload"
              title="Upload"
              onClick={() => {
                if (field.ref) {
                  field.ref.click();
                }
              }}
            >
              <div className="upload mr-0"></div>
            </Button>
          </div>
          <div className="hl-download-btn hl-file-upload-title">
            <div className="hl-file-title">
              <span title={fileName || uploadedFile}>
                {fileName || uploadedFile}
              </span>
            </div>
          </div>
        </div>
      )}
    />
  );
};

export default FileUploadLegalDocument;